<template>
  <div>
    <navigator :title="serviceChildName" routePath="/property"></navigator>
    <EquipmentDemo :msg="categoryInfo" :isTextOver="false"></EquipmentDemo>
    <div class="content">
      <div class="text" ref="text2" v-html="categoryInfo.content" v-show="formType !== 2"></div>
      <CustomForm :formObj="formInfo" @finishForm="submitForm" v-if="formType === 2"></CustomForm>
    </div>

    <div v-if="categoryInfo.serviceQrcodeList">
      <QrcodeQuickEntry :serviceQrcodeList="categoryInfo.serviceQrcodeList"></QrcodeQuickEntry>
    </div>

    <div class="footer-fixed">
      <mt-button type="danger" class="footer-btn" @click.native="booking" v-if="formType !== 2">提交</mt-button>
    </div>

    <!-- 遮罩 -->
    <div class="modal" v-show='popupVisible'>
      <div class="close" @click="popupVisible=false">
        <van-icon name="close" />
      </div>
      <div class="container">
         <CustomForm :formObj="formInfo" v-if="formType === 3" @finishForm="submitForm"></CustomForm>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Indicator, Toast, Popup } from 'mint-ui';
import { jsTimestampFilter } from '@/utils/filters.js';
import deepcopy from '@/utils/deepcopy';
import EquipmentDemo from '../components/EquipmentDemo';
import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';

export default {
  data() {
    return {
      popupVisible: false,
      categoryInfo: {},
      formType: 0,
      formInfo: {},
      serviceMsg: {},
      serviceChildName: '园区广告位',
      submitting: false,
    }
  },
  components: {
    EquipmentDemo,
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList', 'qrcodeServiceInfo']),
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 2;
      });
      this.getServiceChildName();
    }
    this.getInfo();
  },
  updated() {
    this.$nextTick(() => {
      const imgs = this.$refs.text2.querySelectorAll('img') || [];
      imgs.forEach((val) => {
        val.style.maxWidth = '100%';
      });
    });
  },
  methods: {
    getServiceChildName() {
      const arrIndex = this.serviceMsg.children.findIndex((val) => {
        return this.$route.params.serviceId === val.serviceId;
      });
      if (arrIndex !== -1) {
        this.serviceChildName = this.serviceMsg.children[arrIndex].serviceName;
      } else {
        this.serviceChildName = '设备出租';
      }
    },
    booking() {
      if(this.token == ''){
        this.$root.eventHub.$emit('login', this.$route.fullPath);
        return
      }
      if (this.formType === 3) {  // 富文本+表单
        this.popupVisible = true;
      } else if (this.formType === 1) {
        // 直接预约接口
        this.submitForm();
      }
    },
    getInfo() {  // 获取详情
      Indicator.open('加载中...');
      setTimeout(() => {
        Indicator.close();
      }, 5000);
      this.$http.post(`${this.URL_PREFIX}/app/get/facilities/rent/detail`, {
        parkId: this.currentParkId,
        serviceId: this.$route.params.serviceId,
        facilitiesId: this.$route.params.facilitiesId,
        qrId: this.$route.query.qrId || '',
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        Indicator.close();
        if (res.resCode === '10000') {
          this.categoryInfo = res.resData;
          this.formType = res.resData.formType;  // 判断内容
          this.serviceChildName = res.resData.serviceName
          if (res.resData.formType !== 1) {
            this.formInfo = deepcopy(res.resData.customForm);
            // this.formInfo.itemList = this.formInfo.customForm.itemList;   // 排除报错
            this.formInfo.itemList.forEach((val) => {
              val.options = val.options ? val.options.split(',') : [];
              val.validate = false;
              if (val.type === 4) {
                val.defaultValue = jsTimestampFilter(new Date().getTime());
              } else if(val.type === 6) {
                val.defaultValue = [];
              } else if (val.type === 3) {
                val.defaultValue = parseFloat(val.defaultValue);
              } else if (val.type === 7) {
                val.defaultValue = parseFloat(val.defaultValue) ? val.defaultValue : 9;
              }
            })
          }
        } else if(res.resCode !== '10000') {
          Toast(res.resDesc);
          this.$router.replace('/index')
        } else if(Object.keys(res.resData).length == 0){
          Toast('服务不存在或已被下架');
          this.$router.replace('/index')
        }
      });
    },
    submitForm(content) {  // 提交表单
      if(this.submitting){
        return
      }
      this.submitting = true;

      Indicator.open('正在提交...');
      setTimeout(() => {
        Indicator.close();
      }, 5000);
      const orderBody = {
        parkId: this.currentParkId,
        serviceId: this.$route.params.serviceId,
        bindingId: this.$route.params.facilitiesId,
        qrId: this.$route.query.bindQr==1 ? (this.qrcodeServiceInfo.qrId || undefined) : undefined,
      }
      if (this.formType !== 1) {
        orderBody.formId = this.categoryInfo.formId;
        orderBody.content = content;
      }
      this.$http.post(`${this.URL_PREFIX}/app/added/park/service/form/order`, orderBody,
      {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.popupVisible = false;
        Indicator.close();
        if (res.resCode === '10000') {
          Toast('订单提交成功！');
          if (res.resData.orderFee && res.resData.orderFee > 0) {
            let query = {
              orderId: res.resData.orderId,
              price: res.resData.orderFee,
            }
            this.$router.push({path:'/payment', query:query});
          }
        } else {
          Toast(res.resDesc);
        }
        this.submitting = false;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';

.content {
  background-color: #fff;
  min-height: 4rem;
  // margin: .133333rem 0;
  margin-bottom: 2.86rem;
  .text {
    padding: .32rem;
    margin-bottom: 1.66rem;
  }
}
.mint-popup {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  p {
    padding-top: 20px;
    padding-left: 10px;
  }
}
.myButton {
  width: 90%;
  margin: 0 .426667rem;
  position: fixed;
  bottom: 10px;
}
.footer-fixed{
  padding: px2rem(16) px2rem(24);
  background-color: #f5f5f5;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  bottom: 0;
  .footer-btn{
    width: 100%;
    background: $color-main;
    color: #fff;
    font-size: .4rem;
  }
}

// 遮罩
.modal {
  @include modify_info;
}

</style>



// WEBPACK FOOTER //
// src/pages/business/child/EquipmentInfo.vue